import React from 'react';
import Svg, {
  Defs, G, Path, Rect, Circle,
} from 'react-native-svg';
import isMobile from '../../../components/IsMobile';

const NoBuildingImage = () => <Svg width='216' height='121' viewBox='0 0 216 121' fill='none'>
  <Rect x='31' width='154' height='120' rx='8' fill='#E6EEF7' />
  <G filter='url(#filter0_d_179_12921)'>
    <Rect x='7' y='8' width='152' height='48' rx='4' fill='white' />
    <Circle cx='35' cy='32' r='16' fill='#548FC8' />
    <Path d='M27.1429 40.1484V30.7198H30.2858M30.2858 30.7198V40.1484M30.2858 30.7198V24.4341H39.7144V30.7198M39.7144 40.1484V30.7198M33.4287 40.1484V33.8627H36.5715V40.1484M39.7144 30.7198H42.8572V40.1484M33.4287 27.5769V30.7198H36.5715V27.5769H33.4287Z' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
    <Rect x='63' y='24' width='80' height='16' rx='4' fill='#B0CBE6' />
    <Rect x='7.5' y='8.5' width='151' height='47' rx='3.5' stroke='#F4F7FB' />
  </G>
  <G filter='url(#filter1_d_179_12921)'>
    <Rect x='57' y='64' width='152' height='48' rx='4' fill='white' />
    <Circle cx='85' cy='88' r='16' fill='#548FC8' />
    <Path d='M77.1429 96.1484V86.7198H80.2858M80.2858 86.7198V96.1484M80.2858 86.7198V80.4341H89.7144V86.7198M89.7144 96.1484V86.7198M83.4287 96.1484V89.8627H86.5715V96.1484M89.7144 86.7198H92.8572V96.1484M83.4287 83.5769V86.7198H86.5715V83.5769H83.4287Z' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
    <Rect x='113' y='80' width='80' height='16' rx='4' fill='#B0CBE6' />
    <Rect x='57.5' y='64.5' width='151' height='47' rx='3.5' stroke='#F4F7FB' />
  </G>
  {!isMobile && <Defs>
    <filter id='filter0_d_179_12921' x='0' y='3' width='166' height='62' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_179_12921' />
      <feOffset dy='2' />
      <feGaussianBlur stdDeviation='3' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_179_12921' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_179_12921' result='shape' />
    </filter>
    <filter id='filter1_d_179_12921' x='50' y='59' width='166' height='62' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_179_12921' />
      <feOffset dy='2' />
      <feGaussianBlur stdDeviation='3' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_179_12921' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_179_12921' result='shape' />
    </filter>
  </Defs>}
</Svg>;

export default NoBuildingImage;
